import React from "react";

const AvatarCategoryTabs = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="avatar-category-tabs">
      {categories.map((category) => {
        const isActive = activeCategory === category.id;

        return (
          <button
            key={category.id}
            type="button"
            className={`avatar-category-tab ${
              isActive ? "avatar-category-tab-active" : ""
            }`}
            onClick={() => onCategoryChange(category.id)}
            aria-pressed={isActive}
          >
            <span className="avatar-category-label">
              {category.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default AvatarCategoryTabs;